<script setup lang="ts">
import { defineProps } from "vue";

const { title } = defineProps<{ title: string }>();
</script>

<template>
	<div class="settings-row d-flex justify-start align-center py-1">
		<div class="line">
			{{ title }}
		</div>
		<div class="d-flex align-center ml-auto">
			<slot />
		</div>
	</div>
</template>

<style scoped>
.settings-row {
	position: relative;
	padding-left: 24px; /* Offset to leave space for the line */
}

.line {
	position: relative;
}

/* the line itself */
.line::before {
	content: "";
	position: absolute;
	left: -16px; /* Adjust as needed to center the line */
	top: -12px;
	bottom: -18px;
	width: 2px;
	background-color: rgb(var(--color-secondary));
}

/* the 'dot' in front of every entry */
.line::after {
	content: "";
	position: absolute;
	left: -20px;
	top: 9px;
	width: 10px;
	height: 10px;
	background-color: rgb(var(--color-secondary));
	border-radius: 50%;
	z-index: 10;
}
</style>
